<template>
  <section class="relative w-full main-page py-10 sm:py-40 min-h-screen">
    <div class="container mx-auto px-4 h-full">
      <div class="grid h-full place-items-center my-20 sm:my-auto">
        <div class="w-11/12 p-12 sm:w-8/12 md:w-6/12 lg:w-5/12 2xl:w-4/12 px-6 py-10 sm:px-10 sm:py-6 bg-white rounded-lg shadow-md lg:shadow-lg">
          <div class="flex">
            <span class="text-center font-bold my-5 mx-auto">
              <a href="/" class="text-gray-800 font-bold text-2xl">
                <span class="text-black">
                  FPV<br>
                  Обратная связь
                </span>
              </a>
            </span>
          </div>

          <div v-if="success" class="mt-6 bg-emerald-50 border border-emerald-200 rounded-lg p-6 text-center">
            <p class="text-emerald-700 font-semibold text-lg">Ваше сообщение отправлено!</p>
            <p class="text-emerald-600 text-sm mt-2">Модератор рассмотрит ваш запрос в ближайшее время и ответит по указанным контактам</p>
            <router-link
              :to="backUrl"
              class="inline-block mt-4 px-6 py-2 bg-gray-800 text-white rounded hover:bg-gray-700 transition text-sm"
            >
              Назад
            </router-link>
          </div>

          <form v-else class="mt-6" @submit.prevent="submit">
            <div class="text-center mb-6">
              <p class="text-sm text-gray-700 font-semibold">Контакты технической поддержки</p>
              <p class="text-sm text-gray-500">Свяжитесь с нами и мы с радостью</p>
              <p class="text-sm text-gray-500">ответим на ваши вопросы и поможем</p>
              <p class="text-sm text-gray-500">решить возникшие проблемы</p>
            </div>

            <label class="block text-xs font-semibold text-gray-600 uppercase">Имя</label>
            <input
              v-model="form.name"
              type="text"
              placeholder="Введите ваше имя"
              required
              class="block w-full py-3 px-1 mt-2 text-gray-800 appearance-none border-b-2 border-gray-100 focus:text-gray-500 focus:outline-none focus:border-gray-200"
            />

            <label class="block mt-4 text-xs font-semibold text-gray-600 uppercase">Телефон или почта для связи</label>
            <input
              v-model="form.contact"
              type="text"
              placeholder="+7 (777) 777-77-77 или info@mail.kz"
              required
              class="block w-full py-3 px-1 mt-2 text-gray-800 appearance-none border-b-2 border-gray-100 focus:text-gray-500 focus:outline-none focus:border-gray-200"
            />

            <label class="block mt-4 text-xs font-semibold text-gray-600 uppercase">Описание запроса</label>
            <textarea
              v-model="form.description"
              placeholder="Опишите вашу проблему или запрос"
              required
              rows="4"
              class="block w-full py-3 px-1 mt-2 text-gray-800 appearance-none border-b-2 border-gray-100 focus:text-gray-500 focus:outline-none focus:border-gray-200 resize-none"
            ></textarea>

            <p v-if="error" class="text-red-500 text-sm mt-3">{{ error }}</p>

            <button
              type="submit"
              :disabled="loading"
              class="w-full py-3 mt-8 bg-gray-800 rounded-sm font-medium text-white uppercase focus:outline-none hover:bg-gray-700 hover:shadow-none disabled:opacity-50"
            >
              {{ loading ? 'Отправка...' : 'Отправить' }}
            </button>

            <div class="text-center mt-6">
              <router-link :to="backUrl" class="text-sm text-gray-500 underline">
                Назад
              </router-link>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios';
import { API_USER_FEEDBACK, HEADERS_JSON } from '@/const/uri';

export default {
  computed: {
    backUrl() {
      return this.$route.query.from || '/client/login';
    },
  },
  data() {
    return {
      form: {
        name: '',
        contact: '',
        description: '',
      },
      loading: false,
      success: false,
      error: '',
    };
  },
  methods: {
    async submit() {
      this.error = '';
      this.loading = true;
      try {
        await axios.post(API_USER_FEEDBACK.create, this.form, {
          headers: HEADERS_JSON,
        });
        this.success = true;
      } catch (e) {
        this.error = e.response?.data?.detail || 'Ошибка при отправке. Попробуйте позже.';
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
